import $ = require("jquery");
import * as Service from "./Service";
import * as Logger from "./Logger";
import moment = require("moment");
import { computePosition, flip, shift, offset } from "@floating-ui/dom";
import { InternalSettings } from "datatables.net-bs4";


let lastFocusedItem: JQuery = null;
const busySpinnerClass = "material-icons spin-cw ml-2";

export function setBusy(targetSelector) {
    if (targetSelector) {
        const button = $(targetSelector);
        let iconElement = button.find("i");
        if (iconElement.length !== 0) {
            iconElement.hide();
        }
        var spinner = "<span class='spinnericon'><span class='spinner-border spinner-border-sm mr-1' aria-hidden='true'></span><span role='status' class='sr-only'> Loading...</span></span>";
        button.prepend($(spinner));
        button.prop("disabled", true);
    }
}



export function clearBusy(targetSelector) {
    if (targetSelector) {
        const button = $(targetSelector);
        var spinner = button.find("span.spinnericon");
        if (spinner.length !== 0) {
            spinner.remove();
        }
        const iconElement = button.find("i");
        if (iconElement.length !== 0) {
            iconElement.show();
        }
        button.removeAttr("disabled");
    }
}

export function setBusyIcon(targetSelector) {
    if (targetSelector) {
        const button = $(targetSelector);
        let iconElement = button.next("i:contains(sync)");
        if (iconElement.length === 0) {
            const icon = $('<i class="' + busySpinnerClass + '" style="inline-block">sync</i>');
            button.after(icon);
            iconElement = button.find("i:contains(sync)");
        }
        const previousIconClass = iconElement.attr("class");
        iconElement.data("setBusy_previousClass", previousIconClass);
        iconElement.removeClass().addClass(busySpinnerClass);
        iconElement.show();
        button.prop("disabled", true);
    }
};

export function clearBusyIcon(targetSelector) {
    if (targetSelector) {
        const button = $(targetSelector);
        const iconElement = button.next("i:contains(sync)");
        const previousClass = iconElement.data("setBusy_previousClass");
        iconElement.removeClass(busySpinnerClass);
        if (previousClass) {
            iconElement.addClass(previousClass);
        }
        iconElement.hide();
        button.removeAttr("disabled");
    }
}

//static registerDownloadButton(buttonId: string) {
//    var targetSelector = "#" + buttonId;
//    var button = $(targetSelector);
//    var downloadUrl = button.attr("href");

//    button.on("click", function () {
//        Controls.setBusy(targetSelector);

//        $.fileDownload(downloadUrl, {
//            successCallback: function (url) {
//                Controls.clearBusy(targetSelector);
//            },
//            failCallback: function (html, url) {
//                Controls.clearBusy(targetSelector);
//                Service.reportMessageResultError("Error while getting report at url " + url, "Report Error", "There was an error generating your report.  This error has been reported to the application development team.");
//            }
//        });
//        return false;
//    });

//}

//static registerDateBox(dateboxId) {
//    $("#" + dateboxId).datepicker();
//}

export function registerTimeBox(timeboxId) {
    $("#" + timeboxId).on("change", function () {
        let parsed = Service.parseDate($(this).val());
        if (parsed) {
            parsed = Service.formatTime(parsed);
            $(this).val(parsed);
        } else {
            $(this).val("");
        }
    });
}

export function sleepAsync<T>(timeOutMs: number, resolutionValue?: T) {
    return new Promise<T>(resolve => { window.setTimeout(() => { resolve(resolutionValue); }, timeOutMs) });
}

const defaultSecondsToDisplay = 5;
const defaultUndoText = "Undo";
export type SnackbarPosition = "left" | "center" | "right";
interface ISnackbarMessage {
    message: string;
    position: SnackbarPosition;
    showCloseButton: boolean;
    secondsToDisplay: number; //number of seconds to display snackbar
    showUndoButton: boolean;
    undoButtonText: string;  //text to use for the undo button
    undoButtonAction: Function;  //action to take when clicking undo button
    closeAction: Function; //action to take when the snackbar has closed (either normally or through user action)
}

//Global snackbar variables
const snackbar = $("#globalSnackbar");
const snackbarQueue: ISnackbarMessage[] = [];

//Display material design snackbar message
function displaySnackbar(msg: ISnackbarMessage) {
    const msgContainer = snackbar.find(".snackbar-body");
    if (msg.message.length > 72) {
        snackbar.addClass("snackbar-multi-line");
    }
    else if (msg.message.length > 50 && msg.showUndoButton) { //make space for undo button
        snackbar.addClass("snackbar-multi-line");
    }
    else {
        snackbar.removeClass("snackbar-multi-line");
    }
    const btn = $("#globalSnackbarBtn");
    msg.showCloseButton ? btn.removeClass("d-none") : btn.addClass("d-none");

    msgContainer.text(msg.message);

    snackbar.removeClass("snackbar-left").removeClass("snackbar-right");
    if (msg.position === "left")
        snackbar.addClass("snackbar-left");
    else if (msg.position === "right")
        snackbar.addClass("snackbar-right");

    const undoBtn = $("#globalSnackbarUndoBtn");
    undoBtn.text(msg.undoButtonText);
    if (msg.showUndoButton && msg.undoButtonAction) {
        undoBtn.removeClass("d-none");
    } else {
        undoBtn.addClass("d-none");
        undoBtn.off("click");
    };

    snackbar.addClass("show");
};

//Hide material design snackbar message
export function hideSnackbar() {
    snackbar.removeClass("show");
};

function closeBtnClickAsync() {
    const btn = $("#globalSnackbarBtn");
    return new Promise<void>(resolve => btn.on("click", () => resolve()));
}

function undoBtnClickAsync(msg: ISnackbarMessage) {
    const undoBtn = $("#globalSnackbarUndoBtn");
    if (msg.showUndoButton && msg.undoButtonAction) {
        undoBtn.off("click");
        return new Promise(resolve => undoBtn.on("click",
            function (e) { resolve(msg.undoButtonAction(e)); }
        ));
    } else {
        return;
    };
}

async function processSnackBarQueue() {
    if (snackbarQueue.length > 0) {
        const message = snackbarQueue[0]; //Read first item in queue, but don't 
        displaySnackbar(message);
        const displayMilliseconds = message.secondsToDisplay * 1000;

        if (message.showUndoButton) {
            await Promise.race([sleepAsync(displayMilliseconds), undoBtnClickAsync(message)]);
            $("#globalSnackbarUndoBtn").off("click");
        }
        else if (message.showCloseButton) {
            await Promise.race([sleepAsync(displayMilliseconds), closeBtnClickAsync()]);
            $("#globalSnackbarBtn").off("click");
        }
        else if (message.showUndoButton && message.showCloseButton) {
            await Promise.race([sleepAsync(displayMilliseconds), undoBtnClickAsync(message), closeBtnClickAsync()]);
            $("#globalSnackbarUndoBtn").off("click");
            $("#globalSnackbarBtn").off("click");
        }
        else {
            await sleepAsync(displayMilliseconds); //Display the snack bar for the timeout interval
        }

        hideSnackbar();
        if (message.closeAction) {
            message.closeAction();
        }
        await sleepAsync(500); //Wait 500ms before cleaning up and resolving to give time for the hide animation to work
        snackbarQueue.shift(); //Remove item from queue
        console.log("Snackbar queue length: " + snackbarQueue.length);
        processSnackBarQueue();
    }
}

function queueSnackBar(message: ISnackbarMessage) {
    snackbarQueue.push(message);
    console.log("Snackbar queue length: " + snackbarQueue.length);
    if (snackbarQueue.length === 1) {
        processSnackBarQueue();
    };
}

export function displaySuccessMessage(successMessage: string, position?: SnackbarPosition, showCloseButton?: boolean, secondsToDisplay?: number, showUndoButton?: boolean, undoButtonText?: string, undoButtonAction?: any, closeAction?: any) {
    const msg = { message: "SUCCESS! " + successMessage, position: position || "center", showCloseButton: showCloseButton || false, secondsToDisplay: secondsToDisplay || defaultSecondsToDisplay, showUndoButton: showUndoButton || false, undoButtonText: undoButtonText || defaultUndoText, undoButtonAction: undoButtonAction || undefined, closeAction: closeAction || undefined } as ISnackbarMessage;
    queueSnackBar(msg);
    //new PNotify({ title: successTitle || "Success", text: successMessage, type: "success", delay: 6000 });
}

export function displayErrorMessage(errorMessage: string, position?: SnackbarPosition, showCloseButton?: boolean, secondsToDisplay?: number, showUndoButton?: boolean, undoButtonText?: string, undoButtonAction?: any, closeAction?: any) {
    const msg = { message: "ERROR! " + errorMessage, position: position || "center", showCloseButton: showCloseButton || false, secondsToDisplay: secondsToDisplay || defaultSecondsToDisplay, showUndoButton: showUndoButton || false, undoButtonText: undoButtonText || defaultUndoText, undoButtonAction: undoButtonAction || undefined, closeAction: closeAction || undefined } as ISnackbarMessage;
    queueSnackBar(msg);
    //new PNotify({ title: errorTitle || "Error", text: errorMessage, type: "error", delay: 6000 });
}

export function displayMessage(message: string, position?: SnackbarPosition, showCloseButton?: boolean, secondsToDisplay?: number, showUndoButton?: boolean, undoButtonText?: string, undoButtonAction?: any, closeAction?: any) {
    const msg = { message: message, position: position || "center", showCloseButton: showCloseButton || false, secondsToDisplay: secondsToDisplay || defaultSecondsToDisplay, showUndoButton: showUndoButton || false, undoButtonText: undoButtonText || defaultUndoText, undoButtonAction: undoButtonAction || undefined, closeAction: closeAction || undefined } as ISnackbarMessage;
    queueSnackBar(msg);
}

export function highlightRow(row, fadeDelay?: number) {
    if (!fadeDelay) {
        fadeDelay = 2000;
    }
    $(row).addClass("highlight").delay(fadeDelay).queue(function () {
        $(this).removeClass("highlight");
        $(this).dequeue();
    });
}

export function beginTrackingFocus() {
    lastFocusedItem = null;
    $(".track_focus").focus(function () {
        lastFocusedItem = $(this);
        const contentRestriction = $(this).attr("data-restrictMergeContent");
        if (contentRestriction) {
            $(".mergeitem[data-contenttype='" + contentRestriction + "']").prop("disabled", false).attr("title", "");
            $(".mergeitem[data-contenttype!='" + contentRestriction + "']").prop("disabled", true).attr("title", "this field cannot be chosen for the selected textbox");
        } else {
            $(".mergeitem").prop("disabled", false).attr("title", "");
        }
    });
}

function insertAtCaret(txtarea?: HTMLTextAreaElement, text?) {
    if (txtarea) {
        const scrollPos = txtarea.scrollTop;
        let strPos = 0;
        const br = ((txtarea.selectionStart || txtarea.selectionStart === 0) ? "ff" : (document["selection"] ? "ie" : false));
        if (br === "ie") {
            txtarea.focus();
            const range = document["selection"].createRange();
            range.moveStart('character', -txtarea.value.length);
            strPos = range.text.length;
        } else if (br === "ff") {
            strPos = txtarea.selectionStart;
        }

        const front = (txtarea.value).substring(0, strPos);
        const back = (txtarea.value).substring(strPos, txtarea.value.length);
        txtarea.value = front + text + back;
        strPos = strPos + text.length;
        if (br === "ie") {
            txtarea.focus();
            const range = document["selection"].createRange();
            range.moveStart('character', -txtarea.value.length);
            range.moveStart('character', strPos);
            range.moveEnd('character', 0);
            range.select();
        } else if (br === "ff") {
            txtarea.selectionStart = strPos;
            txtarea.selectionEnd = strPos;
            txtarea.focus();
        }
        txtarea.scrollTop = scrollPos;
    }
}

function flashForegroundColor(targetElement: JQuery, color) {
    let originalColor = targetElement.css("color");
    if (!originalColor) {
        originalColor = "black";
    }
    targetElement.css("color", color);
    targetElement.animate({ color: originalColor }, 1000);
}

export function insertAtLastFocusedCaret(text) {
    const focusedItem = lastFocusedItem;
    if (focusedItem && focusedItem.length > 0) {
        insertAtCaret(focusedItem[0] as HTMLTextAreaElement, text);
        flashForegroundColor(focusedItem, "#93FF28");
        focusedItem.keyup();
    }
}

export function registerDateSpanDisplays() {
    $(document).ready(() => {
        $("span.date-display").each((idx, val) => {
            const dt = $(val).attr("data-isoDateUtc");
            let m = moment.utc(dt);
            if (m.isValid()) {
                m = m.local();
                const localTime = m.locale(navigator.language).format('L LT');
                const utcTime = moment.utc(dt).format("YYYY-MM-DD HH:mm:ss Z");
                const newElement = $(`<time datetime="${dt}" title="${utcTime}">${localTime}</time>`);
                $(val).replaceWith(newElement);
            }
        });

    });
}

export function getJquerySelectorPath(element: HTMLElement): string {
    const elem = $(element);
    if (elem.length !== 1) throw 'Requires one element.';

    let path: string = null;
    let node = elem;
    while (node.length) {
        const realNode = node[0]
        let name = realNode.localName;
        if (!name) break;
        name = name.toLowerCase();

        const parent = node.parent();

        const siblings = parent.children(name);
        if (siblings.length > 1) {
            name += ':eq(' + siblings.index(realNode) + ')';
        }

        path = name + (path ? '>' + path : '');
        node = parent;
    }

    return path;
}

export function renderCheckboxIcon(checked: boolean, checkedTitle?: string, uncheckedTitle?: string): string {
    checkedTitle = checkedTitle || "Active";
    uncheckedTitle = uncheckedTitle || "Inactive";
    return `<i class="material-icons" aria-hidden="true" title="${checked ? checkedTitle : uncheckedTitle}">${checked ? "check_box" : "check_box_outline_blank"}</i><span class="sr-only">${checked ? checkedTitle : uncheckedTitle}</span>`;
}

export interface IMultiform {
    initializeMultiformBehavior(target, moveRowUp, moveRowDown): void;
    refreshMultiformBehavior(target, clobber?): void;
}

export const multiform: IMultiform = (() => {
    const that: any = {};
    let moveUp, moveDown;
    const focusedPositionIndex = "focusedPositionIndex";
    const l = message => { Logger.log(message); };

    const focusCellPosition = (target, positionIndex) => {
        l("positionIndex is " + positionIndex);
        if (positionIndex !== undefined && positionIndex !== null) {
            l("trying to set focused dNd cell at position " + positionIndex);
            const row = ($(target)[0] as any).tBodies[0].rows[positionIndex];
            if (row) {
                $(row).find(".dNdCell").focus();
            }
            $(target).data(focusedPositionIndex, null);
        };

    };
    const initializeDndCell = (cell: JQuery, clobber?) => {
        //setting the tabindex to -1 to remove from tab order since there are up/down buttons to accomplish this and the drag itself can't be activated via a keyboard.  Leaving other attributes in place since the cell can still be read.
        cell.attr("tabindex", -1).attr("aria-grabbed", "false").focus(function () { $(this).attr("aria-grabbed", "true").addClass("move-icon").parents("tr").addClass("focused").attr("aria-focused", "true"); }).blur(function () { $(this).attr("aria-grabbed", "false").removeClass("move-icon").parents("tr").removeClass("focused").removeAttr("aria-focused"); }).keydown(function (event) {
            let focusedPosition = null;
            const targetTable = $(this).closest("table");
            if (targetTable.length > 0) {
                if (event.which === 38 && moveUp) {
                    focusedPosition = moveUp($(this)[0]);
                } else if (event.which === 40 && moveDown) {
                    focusedPosition = moveDown($(this)[0]);
                }
                if (focusedPosition === undefined) {
                    focusedPosition = null;
                }
                l("setting focused position to " + focusedPosition);
                focusCellPosition(targetTable, focusedPosition);
            }

        });

        cell.parents("tr").hover(function () {
            if (!$(this).hasClass("nodrag")) {
                $(this.children[0]).addClass('move-icon');
            }
        }, function () {
            $(this.children[0]).removeClass("move-icon");
        });
    };


    that.initializeMultiformBehavior = (target, moveRowUp, moveRowDown) => {
        moveUp = moveRowUp;
        moveDown = moveRowDown;
        initializeDndCell($(target).find("tr td .dNdCell"));
    };
    that.refreshMultiformBehavior = (target, clobber) => {
        initializeDndCell($(target).find("tr td .dNdCell"), clobber);
    };

    return that;
})();

//enables using the Popover.js library
export function enablePopovers() {

    jQuery("[data-toggle='popover']").popover();
    jQuery(".popover-dismiss").popover({
        trigger: "focus"
    });

    jQuery('#page-content').popover({
        selector: "[rel=popover]",
        html: true,
        trigger: 'focus',
        content: function () {
            return $($(this).data('contentwrapper')).html();
        }
    });

    jQuery('.modal').popover({
        selector: "[rel=popover]",
        html: true,
        container: "body",
        trigger: 'focus',
        content: function () {
            return $($(this).data('contentwrapper')).html();
        }
    });
};

//enables the floating-ui library ... update from popover.js
export function enableTooltips() {
    //wire up events onto body so that we can use tooltips on elements that are inserted dynamically after page load
    var body = document.getElementsByTagName("body")[0];
    body.addEventListener("focus", function(e) {
        // console.log("BODY FOCUS");
        // console.log(e.target);
        if ((e.target as HTMLButtonElement).classList.contains("tooltip-btn")) {
            let ttBtn = e.target as HTMLButtonElement;
            let ttContents: HTMLElement = ttBtn.parentElement.querySelector(".tooltipPopup"); //get the tooltip contents
            //display the tooltip offscreen so that floating-ui can place it without flickering on screen
            //this is the starting location based on css, but needs to be reset each time the tooltip is displayed to show in the same location
            ttContents.style.left = "-10000px";
            ttContents.style.top = "0px";
            ttContents.style.display = "block";

            computePosition(ttBtn, ttContents, {
                placement: "left",
                middleware: [flip(), shift({ padding: 5 }), offset(30)]
            }).then(({ x, y }) => {
                Object.assign(ttContents.style, {
                    left: `${x}px`,
                    top: `${y}px`,
                    display: "block"
                });
            });
        }
    }, true);

    body.addEventListener("blur", function (e) {
        // console.log("BODY BLUR");
        // console.log(e.target);
        if ((e.target as HTMLButtonElement).classList.contains("tooltip-btn")) {
            let ttBtn = e.target as HTMLButtonElement;
            let ttContents: HTMLElement = ttBtn.parentElement.querySelector(".tooltipPopup"); //get the tooltip contents
            ttContents.style.display = "none";
        }
    }, true);

    body.addEventListener("keydown", function (e) {
        // console.log("BODY keydown");
        // console.log(e.target);
        const KEYCODE_ESC = 27;
        if ((e.target as HTMLButtonElement).classList.contains("tooltip-btn")) {
            //Dismiss the tooltip when the user hits the Escape key
            let escapePressed = e.key === "Esc" || e.key === "Escape" ||  e.keyCode === KEYCODE_ESC;
            if (escapePressed){
                let ttBtn = e.target as HTMLButtonElement;
                let ttContents: HTMLElement = ttBtn.parentElement.querySelector(".tooltipPopup"); //get the tooltip contents
                ttContents.style.display = "none";
            }
        }
    }, true);            
};

export function transactionStatusLabelClass(status: string) {
    var retVal: string;
    switch (status) {
    case "Failure":
    case "Void":
        retVal = "badge-danger";
        break;
    case "Promised":
        retVal = "badge-warning";
        break;
    case "InProgress":
        retVal = "badge-warning";
        break;
    case "Success":
        retVal = "badge-success";
        break;
    case "Refunded":
        retVal = "badge-info";
        break;
    case "New":
    default:
        retVal = "badge-secondary";
    };
    return retVal;
}

//Update keyboard interaction for tab panels
export function ariaTabs() {
    console.log("running aria tabs");
    const tabs = $("[role='tablist'] [role='tab']");
    const tabsArray = tabs.toArray();
    tabs.each(
        function (index, element) {
            //Set inital tabindex state
            const tab = $(element);
            if (tab.attr("aria-selected") === "true") {
                tab.attr("tabindex", 0);
            } else {
                tab.attr("tabindex", -1);
            };
            //Add keyboard handlers
            tab.on("keydown", function (event) {
                const currentTab = $(event.target);
                if (event.keyCode === 37) { //left arrow
                    console.log("left arrow");
                    //find the index of the tab
                    const ind = tabsArray.findIndex(function (elem) {
                        return elem === element;
                    });
                    if (ind > 0) { //Move left one tab is there's a tab to move to
                        const newFocusedTab = $(tabsArray[ind - 1]);
                        newFocusedTab.focus();
                        currentTab.attr("tabindex", -1)
                        newFocusedTab.attr("tabindex", 0);
                        jQuery(newFocusedTab).trigger("click");
                    }
                } else if (event.keyCode === 39) { //right arrow
                    console.log("right arrow");
                    //find the index of the tab
                    const ind = tabsArray.findIndex(function (elem) {
                        return elem === element;
                    });
                    if (ind < tabsArray.length - 1) { //Move right one tab is there's a tab to move to
                        const newFocusedTab = $(tabsArray[ind + 1]);
                        newFocusedTab.focus();
                        currentTab.attr("tabindex", -1)
                        newFocusedTab.attr("tabindex", 0);
                        jQuery(newFocusedTab).trigger("click");
                    }
                }
            });
            //Adjust tabindex when using the mouse
            tab.on("click", function (event) {
                //clicked tab gets 0 others get -1
                tabsArray.forEach(function (elem) {
                    if (elem === event.target) {
                        elem.setAttribute("tabindex", "0");
                    } else {
                        elem.setAttribute("tabindex", "-1");
                    }
                })
            });
        });
};

export function enableModalFocusTrap() {
    $("[role='dialog']").each((index, element) => {
        $(element).on("shown.bs.modal", (e) => {
            startModalFocusTrap(e.target);
        });
        $(element).on("hidden.bs.modal", (e) => {
            endModalFocusTrap(e.target);
        })
    });
}

//In a modal, trap tabbing so that on elements in the modal can be focused
export function startModalFocusTrap(modalElement) {
    let focusableSelector = "a[href]:not([tabindex='-1']),button:not([tabindex='-1']),textarea:not([tabindex='-1']),input:not([type='hidden']):not([tabindex='-1']),select:not([tabindex='-1']),[tabindex]:not([tabindex='-1'])";
    //console.log("Starting modal focus trap for...");
    //console.log(modalElement);
    //Because the status of controls in the modal can change, we will get a list of all interactive controls and check if they are disabled when decided what to focus on.
    let focusElements = modalElement.querySelectorAll(focusableSelector);
    const KEYCODE_TAB = 9;
    //set focus on the first element of the modal to be nice to the user and to start the trap.
    //scripts for individual pages will run later so can set focus to something else if desired.
    let first = getFirstActiveFocusable(focusElements)
    if (first) {
        first.focus({ focusVisible: true });
    }

    $(modalElement).on("keydown.mft", (e) => {
        var tabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;
        if (!tabPressed)
            return;
        //When tabbing, look in the list of focusable elements for the first or last since whether they are disabled or not may have changed since the modal was opened
        focusElements = modalElement.querySelectorAll(focusableSelector);
        //console.log("focusable...");
        //console.log(focusElements);
        if (e.shiftKey) { //shift-tab
            if (document.activeElement == getFirstActiveFocusable(focusElements)) {
                let last = getLastActiveFocusable(focusElements);
                if (last) {
                    last.focus({ focusVisible: true });
                    e.preventDefault();
                }
            }
        } else { //tab
            //console.log(document.activeElement);
            //console.log(getLastActiveFocusable(focusElements));
            if (document.activeElement == getLastActiveFocusable(focusElements)) {
                first = getFirstActiveFocusable(focusElements);
                if (first) {
                    first.focus({ focusVisible: true });
                    e.preventDefault();
                }
            }
        }
    });
}

function getFirstActiveFocusable(elements: any[]) {
    //console.log("Finding first element");
    for (var i = 0; i < elements.length; i++) {
        if (!elements[i].disabled) {
            //console.log("First active element...");
            //console.log(elements[i]);
            return elements[i];
        }
    };
    return null; //Everything is disabled.
}

function getLastActiveFocusable(elements: any[]) {
    //console.log("Finding last element");
    for (var i = elements.length - 1; i >= 0; i--) {
        //console.log(i);
        //console.log(elements[i]);
        if (!elements[i].disabled) {
            //console.log("Last active element...");
            //console.log(elements[i]);
            return elements[i];
        }
    }
    return null; //Everything is disabled.
}

//Remove the modal trap
export function endModalFocusTrap(modalElement){
    //console.log("Ending modal focus trap for...");
    //console.log(modalElement);
    $(modalElement).off("keydown.mft");
}

//When clicking on a dropdown menu, set the focus to the first item in the menu
export function setMenuFocus(elem?: JQuery | Node) {
    let menus: JQuery;
    if (elem) {
        menus = $("button[aria-haspopup='true'][data-toggle='dropdown']", elem);
    } else {
        menus = $("button[aria-haspopup='true'][data-toggle='dropdown']");
    }
    menus.each((index, element) => {
        let btn = $(element);
        if (btn.attr("aria-controls") && btn.closest(".dropdown")) {
            btn.closest(".dropdown").off("shown.bs.dropdown").on("shown.bs.dropdown", (e) => {
                //console.log("shown.bs.dropdown...");
                //console.log(e);
                let ddBtn = $(e.relatedTarget);
                if (ddBtn.attr("aria-controls")) {
                    let ddMenu = $("#" + ddBtn.attr("aria-controls"));
                    //ddMenu.off("keydown").on("keydown", (ev) => {
                    //    manageMenuFocusOnKeyDown(ev);
                    //});

                    let ddMenuItems = ddMenu.find("[role='menuitem']:visible");
                    $.merge(ddMenuItems, ddMenu.find("[role='menuitem']:visible").find("button:visible,a:visible")); //look for possible focusable controls inside the menuitem
                    ddMenuItems.each((index, elem) => {
                        if (index === 0) {
                            elem.tabIndex = 0;
                            elem.focus();
                        }
                        else {
                            elem.tabIndex = -1;
                        }
                        //    $(elem).off("keydown.menu");
                        //    $(elem).on("keydown.menu", (ev) => {
                        //        manageMenuFocusOnKeyDown(ev);
                        //    });
                    });
                }
            }).off("keydown.menu").on("keydown.menu", (ev) => {
                //console.log("keydown event on the .dropdown");
                manageMenuFocusOnKeyDown(ev);
            });
        }
    });
}

let manageMenuFocusOnKeyDown = (ev) => {
            //TODO:  Bootstrap handles the basic up and down but not wrapping.  Figure out how to override their focus that prevents wrapping around with up and down arrow.
            //console.log("Keydown event...");
            //console.log(ev);
            //let menuContainer = $(ev.target).closest("[role='menu']");
            let menuContainer = $(ev.currentTarget); //container with controls
            let menuItems = menuContainer.find("[role='menuitem']");
            $.merge(menuItems, menuContainer.find("[role='menuitem']").find("button,a")); //look for possible focusable controls inside the menuitem

            //on keydown  up and down arrows change focus and wrap.  Home/end & pageup/pagedown to first and last items
            let key = ev.originalEvent.key;
            switch (key) {
                case 'Up':
                case 'ArrowUp':
                    if (ev.target != menuItems.first()[0]) { //previous item.  bootstrap is handling focus
                        ev.target.tabIndex = -1; //the event we are on will lose focus so change tabIndex.  target is the button that has the key event
                        let itemIndex = menuItems.index(ev.target);
                        menuItems[itemIndex - 1].tabIndex = 0;
                    } else { //TODO: wrap from first to last item
                        ev.target.tabIndex = 0; //since bootstrap won't wrap leave the current item focusable
                        //menuItems.last()[0].tabIndex = 0;
                        //menuItems.last().focus();
                    }
                    break;
                case 'Down':
                case 'ArrowDown':
                    if (ev.target != menuItems.last()[0]) { //next item.  bootsrap is handling focus
                        ev.target.tabIndex = -1; //the event we are on will lose focus so change tabIndex.  target is the button that has the key event
                        let itemIndex = menuItems.index(ev.target);
                        menuItems[itemIndex + 1].tabIndex = 0;
                    } else { //TODO: wrap from last to first item
                        ev.target.tabIndex = 0; //since bootstrap won't wrap leave the current item focusable
                        //menuItems.first()[0].tabIndex = 0;
                        //menuItems.first()[0].focus();
                    }
                    break;
                case 'Home':
                case 'PageUp':
                    ev.preventDefault(); //don't scroll the view port, just move focus in menu
                    ev.target.tabIndex = -1; //the event we are on will lose focus so change tabIndex.  target is the button that has the key event
                    //go to first item
                    menuItems.first()[0].tabIndex = 0;
                    menuItems.first().focus();
                    break;
                case 'End':
                case 'PageDown':
                    ev.preventDefault(); //don't scroll the view port, just move focus in menu
                    ev.target.tabIndex = -1; //the event we are on will lose focus so change tabIndex.  target is the button that has the key event
                    //go to last item
                    menuItems.last()[0].tabIndex = 0;
                    menuItems.last().focus();
                    break;
                case 'Tab':
                    //got to next tab stop and close the dropdown
                    let dd = $(ev.target).closest(".dropdown");
                    if (dd.hasClass("show")) {
                        dd.dropdown("toggle");
                    }
                    break;
            }
}

class CheckboxSwitch {
    switchNode: any;
    constructor(domNode) {
        this.switchNode = domNode;
        this.switchNode.addEventListener('focus', () => this.onFocus(event));
        this.switchNode.addEventListener('blur', () => this.onBlur(event));
    }

    //visual focus added to the container to make the relationship between control and state labels visually clear
    onFocus(event) {
        event.currentTarget.parentNode.classList.add('focus');
    }

    onBlur(event) {
        event.currentTarget.parentNode.classList.remove('focus');
    }
}

export function initCheckboxSwitches() {
    // Initialize the switch checkboxes
    document.querySelectorAll('input[type=checkbox][role=switch]')
        .forEach((element) => new CheckboxSwitch(element));
}

const KEYCODE_SPACE = 32;
function buttonKeyDownEventHandler(event: KeyboardEvent) {
            //The default action for space will scroll the page, which we want to disabled in this case.  We will activate the button on keyup.
            // console.log("keydown handler");
            let spacePressed = event.key === ' ' || event.keyCode === KEYCODE_SPACE;
            if (spacePressed){
                // console.log("space pressed");
                event.preventDefault();
            }
}

function buttonKeyUpEventHandler(event: KeyboardEvent) {
            //active on space on keyup;
            // console.log("keyup handler");
            let spacePressed = event.key === ' ' || event.keyCode === KEYCODE_SPACE;
            if (spacePressed){
                // console.log("space pressed");
                (event.target as any).click();
            }
}

//If an element has been marked up with role="button" make sure it behaves like a button 
//We're wiring this up on body to handler dynamically added or redrawn elements such as the headers in DataTables
//Presently, the role has only been added to anchors so we get some functionality for free like being in the tab order and being clickable so we're only adding activation with space bar here
//and it's also added to the sort elements in datatables which have the rest of the functionality added (tabindex & activate on return)
export function addKeyboardHandlerForButtons() {
    var body = document.getElementsByTagName("body")[0];
    body.addEventListener("keydown", function(e) {
        // console.log("BODY KEYDOWN");
        // console.log(e.target);
        let target = e.target as HTMLElement;
        if (target.hasAttribute("role") && target.getAttribute("role") === "button") {
            buttonKeyDownEventHandler(e);
        }
    }, true);

    body.addEventListener("keyup", function(e) {
        // console.log("BODY KEYUP");
        // console.log(e.target);
        let target = e.target as HTMLElement;
        if (target.hasAttribute("role") && target.getAttribute("role") === "button") {
            buttonKeyUpEventHandler(e);
        }
    }, true);
}

const DataTablesColumnSortIndex = "dataTablesColumnSortIndex";  //constatnt for the name we use to store data with jquery data function

//Maintains focus on the sorting buttons inbetween draws for DataTables tables when a user uses a keyboard
//For most tables DataTables handles this, but on some tables it gets lost.  Call this function on the page after the DataTables tables are initialized.
export function enhanceDataTables() {
    // console.log("Enhance data tables");
    $("table").each(function (index) {
        if ($.fn.dataTable.isDataTable(this)) {
            let jqDT = $(this);
            //store the column that had focus in the data object for the table...presists between DT draws
            jqDT.data(DataTablesColumnSortIndex, null);
            //grab the columns before the table redraws
            jqDT.DataTable().on("preDraw.dt", function (event) {
                // console.log("TABLE PREDRAW");
                // console.log(event);
                // console.log(document.activeElement);
                if (document.activeElement.classList.contains("dt-column-order")) {
                    // console.log("Clicked to reorder column")
                    // console.log(document.activeElement.closest("th"));
                    // console.log(document.activeElement.closest("th").cellIndex);
                    //store the column index of the sorting element that we clicked on
                    jqDT.data(DataTablesColumnSortIndex, document.activeElement.closest("th").cellIndex);
                }
            }).on("draw.dt", function (event) {
                // console.log("TABLE DRAW");
                // console.log(event);
                // console.log(document.activeElement);
                let colSortIndex = jqDT.data(DataTablesColumnSortIndex);
                // console.log(colSortIndex);
                //will be null/undefined on page load.  We only want to set focus after a user clicks to sort the table
                if (colSortIndex != null) {
                    (jqDT.DataTable().table(0).header().querySelectorAll("th")[colSortIndex].querySelector(".dt-column-order") as any).focus();
                }
                jqDT.data(DataTablesColumnSortIndex, null); //reset so if we move to another element we don't end up back here after a draw
            });

        }
    });
}

//By default DataTables sets the accessible name of the pagination nav region as 'pagination'.  This will set that name to something
//unique or more descriptive as nav region names need to be unique on the page.
//call this in the "drawCallback" callback of the table
//This change of name appears to survive at least some table redraws, but not sure if there is a case where it would get wiped out so set on every draw to cover that potential case.
export function setDataTablesPaginationName(settings: InternalSettings, navRegionName: string) {
    //Set the accessible name on the pagination nav region to something other than the default of "pagination" so that we know it's unique and easily understood to belong to the table.
    let api = new $.fn.dataTable.Api(settings); //get an api instance for the table
    let tableContainer = api.table(0).container(); //div element containing the table
    var nav = tableContainer.querySelector("nav"); //get the pagination nav and set its accessible name
    if (nav) {
        nav.setAttribute("aria-label", navRegionName)
    }
}